module.exports = __webpack_public_path__ + "img/VintageCarsMasonry.0b07d3bd.jpg";